<script lang="ts" setup>
import { onMounted, nextTick, useTemplateRef, watch } from 'vue';
import FloatNavigator from '@/home/components/FloatNavigator.vue';
import FloatNavigatorItem from '@/home/components/FloatNavigatorItem.vue';

import Description from './components/Description.vue';
import OrganizationStructure from './components/OrganizationStructure.vue';
import Council from './components/Council.vue';
import TechnicalOversightCommitee from './components/TechnicalOversightCommitee.vue';
import SecurityCommitee from './components/SecurityCommitee.vue';
import CloudCommunity from './components/CloudCommunity.vue';

const navigatorRef = useTemplateRef('navigatorEl');

const props = defineProps({
  navigator: {
    type: String,
    default: '',
  },
});

const navigatorMap = {
  introduction: 0,
  structure: 1,
  council: 2,
  toc: 3,
  security: 4,
  cloud: 5,
};

const gotoNavigator = async () => {
  await nextTick();
  const index = navigatorMap[props.navigator as keyof typeof navigatorMap];
  if (index !== undefined) {
    navigatorRef.value?.goto(index);
  }
};

watch(() => props.navigator, (newVal) => {
  if (newVal) {
    gotoNavigator();
  }
});

onMounted(() => {
  setTimeout(() => {
    gotoNavigator();
  }, 400);
});
</script>

<template>
  <main class="page-about">
    <div class="about-title bg-cover bg-center bg-no-repeat"></div>

    <FloatNavigator bar-class="container <xl:px-24 <sm:px-16" ref="navigatorEl">
      <FloatNavigatorItem :label="$t('about.title')">
        <Description />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('about.organizationStructure.title')">
        <OrganizationStructure />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('about.council.title')">
        <Council />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('about.technicalOversightCommitee.title')">
        <TechnicalOversightCommitee />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('about.organizationStructure.structure3.title')">
        <SecurityCommitee />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('about.cloudCommunity.title')">
        <CloudCommunity />
      </FloatNavigatorItem>
    </FloatNavigator>
  </main>
</template>

<style lang="scss" scoped>
.page-about {
  padding-bottom: 80px;
  color: #2d2d2d;

  .about-title {
    height: 400px;
    background-color: #f7f9f9;
    background-image: url(@/home/assets/about/title-bg.jpg);
  }
}

@media (max-width: 1279.9px) {
  .page-about {
    padding-right: 24px;
    padding-left: 24px;
  }
}

@media (max-width: 767.9px) {
  .page-about {
    padding-right: 16px;
    padding-bottom: 40px;
    padding-left: 16px;

    .about-title {
      height: 160px;
      background-size: auto 100%;
    }
  }
}
</style>
